import React from 'react';

const TimelineItem = ({ startdate, enddate, company, role, responsibilities, isRight }) => {  
  return (
    <div className="relative mb-12 md:mb-24">
      {/* Timeline Dot */}
      <div className="absolute left-8 md:left-1/2 transform md:-translate-x-[5px] top-[30px] w-[10px] h-[10px] bg-[#ff00ff] rounded-full z-0">
        <div className="absolute inset-0 bg-[#ff00ff] rounded-full animate-pulse opacity-50"></div>
      </div>

      <div className="flex items-start ml-16 md:ml-0">
        {/* Content positioning */}
        <div className={`w-full flex flex-col md:flex-row ${isRight ? 'md:justify-end' : 'md:justify-start'} gap-4 md:gap-8`}>
          {/* Date Box - Always shown above on mobile, on correct side for desktop */}
          <div className="w-[150px] h-fit bg-transparent border-2 border-cyan-400 rounded p-2 font-mono text-cyan-400 text-center">
            <div>{startdate}</div>
            <div>{enddate}</div>              
          </div>

          {/* Content Box */}
          <div className="w-full md:w-[600px] border-2 border-[#ff00ff] rounded p-4 md:p-6 bg-black relative z-20">
            <div className="flex items-start justify-between gap-4 mb-4">
              <div className="min-w-0">
                <h3 className="text-xl md:text-2xl text-cyan-400 mb-2 font-mono">
                  <a href={company.url} 
                     target="_blank" 
                     rel="noopener noreferrer"
                     className="hover:text-[#ff00ff] transition-colors duration-300">
                    {company.name}
                  </a>
                </h3>
                <h4 className="text-sm md:text-base text-[#ff00ff] font-mono">{role}</h4>
              </div>
              <img 
                src={company.logo} 
                alt={`${company.name} logo`} 
                className="w-20 h-20 md:w-24 md:h-24 object-contain rounded flex-shrink-0"
              />
            </div>

            <div className="space-y-2 md:space-y-3">
              {responsibilities.map((resp, index) => (
                <div key={index} 
                     className="flex group items-start gap-2 cursor-pointer transition-all duration-300">
                  <span className="text-[#ff00ff] mt-1">&#41;</span>
                  <p className="text-sm md:text-base text-green-500 group-hover:text-cyan-400 transition-colors">
                    {resp}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineItem;